import React from 'react';
import LocalizedMessage from 'react-l10n';
import Field from '../fields/Field';
import { getTranslation } from '../../lang/main';

const FORM_LABEL = {
    ReferralCoupon: getTranslation('FIELD.COUPON_CODE'),
    BusinessName: getTranslation('FIELD.REGISTERED_BUSINESS_NAME'),
    ABN: getTranslation('FIELD.ABN'),
    ACN: getTranslation('FIELD.ACN'),
    BankName: getTranslation('FIELD.BANK_NAME'),
    BSB: getTranslation('FIELD.BSB'),
    BankAccountName: getTranslation('FIELD.BANK_ACCOUNT_NAME'),
    BankAccountNumber: getTranslation('FIELD.BANK_ACCOUNT_NUMBER'),
    BankSwiftCode: getTranslation('FIELD.BANK_SWIFT_CODE'),
};

function ReferralCouponFormFields(props) {
    const { formData, onFieldUpdate, showMoreFields } = props;
    let { fieldRefs } = props;

    return (
        <>
            <div className='row row--small'>
                <div className='col-xs-12 col-md-6'>
                    <Field
                        required
                        ref={(r) => (fieldRefs.ReferralCoupon = r)}
                        label={FORM_LABEL['ReferralCoupon']}
                        animatedLabel={FORM_LABEL['ReferralCoupon']}
                        name='ReferralCoupon'
                        value={formData.ReferralCoupon || ''}
                        onChange={onFieldUpdate}
                    />
                </div>
            </div>
            {showMoreFields && (
                <>
                    <div className='row row--small'>
                        <div className='col-xs-12 col-md-12'>
                            <Field
                                required
                                ref={(r) => (fieldRefs.BusinessName = r)}
                                label={FORM_LABEL['BusinessName']}
                                animatedLabel={FORM_LABEL['BusinessName']}
                                name='BusinessName'
                                value={formData.BusinessName || ''}
                                onChange={onFieldUpdate}
                            />
                        </div>
                    </div>
                    <div className='row row--small'>
                        <div className='col-xs-12 col-sm-6'>
                            <Field
                                required
                                ref={(r) => (fieldRefs.ABN = r)}
                                label={FORM_LABEL['ABN']}
                                animatedLabel={FORM_LABEL['ABN']}
                                name='ABN'
                                value={formData.ABN || ''}
                                onChange={onFieldUpdate}
                            />
                        </div>
                        <div className='col-xs-12 col-sm-6'>
                            <Field
                                required
                                ref={(r) => (fieldRefs.ACN = r)}
                                label={FORM_LABEL['ACN']}
                                animatedLabel={FORM_LABEL['ACN']}
                                name='ACN'
                                value={formData.ACN || ''}
                                onChange={onFieldUpdate}
                            />
                        </div>
                    </div>
                    <div className='row row--small'>
                        <div className='col-xs-12 col-sm-12'>
                            <Field
                                required
                                ref={(r) => (fieldRefs.BankName = r)}
                                label={FORM_LABEL['BankName']}
                                animatedLabel={FORM_LABEL['BankName']}
                                name='BankName'
                                value={formData.BankName || ''}
                                onChange={onFieldUpdate}
                            />
                        </div>
                    </div>
                    <div className='row row--small'>
                        <div className='col-xs-12 col-sm-6'>
                            <Field
                                required
                                ref={(r) => (fieldRefs.BSB = r)}
                                label={FORM_LABEL['BSB']}
                                animatedLabel={FORM_LABEL['BSB']}
                                name='BSB'
                                value={formData.BSB || ''}
                                onChange={onFieldUpdate}
                            />
                        </div>
                        <div className='col-xs-12 col-sm-6'>
                            <Field
                                required
                                ref={(r) => (fieldRefs.BankAccountName = r)}
                                label={FORM_LABEL['BankAccountName']}
                                animatedLabel={FORM_LABEL['BankAccountName']}
                                name='BankAccountName'
                                value={formData.BankAccountName || ''}
                                onChange={onFieldUpdate}
                            />
                        </div>
                    </div>
                    <div className='row row--small'>
                        <div className='col-xs-12 col-sm-6'>
                            <Field
                                required
                                ref={(r) => (fieldRefs.BankAccountNumber = r)}
                                label={FORM_LABEL['BankAccountNumber']}
                                animatedLabel={FORM_LABEL['BankAccountNumber']}
                                name='BankAccountNumber'
                                value={formData.BankAccountNumber || ''}
                                onChange={onFieldUpdate}
                            />
                        </div>
                        <div className='col-xs-12 col-sm-6'>
                            <Field
                                required
                                ref={(r) => (fieldRefs.BankSwiftCode = r)}
                                label={FORM_LABEL['BankSwiftCode']}
                                animatedLabel={FORM_LABEL['BankSwiftCode']}
                                name='BankSwiftCode'
                                value={formData.BankSwiftCode || ''}
                                onChange={onFieldUpdate}
                            />
                        </div>
                    </div>
                </>
            )}
        </>
    );
}

// default props
ReferralCouponFormFields.defaultProps = {
    defaultIsRequired: false,
};

export default ReferralCouponFormFields;
